module.exports = __webpack_public_path__ + "img/basket.16fe6bb7.svg";